import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_REFRESH_ON_401 } from '../interceptors/skip-refresh.context';
import { BoAuthUser } from '../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class BoAuthApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  public me(accessToken: string): Observable<BoAuthUser> {
    return this.http
      .get<{ data: BoAuthUser }>(`${this.baseUrl}/auth/me`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        context: new HttpContext().set(SKIP_REFRESH_ON_401, true),
      })
      .pipe(map(response => response.data));
  }

  public reportRefreshReuse(): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/auth/refresh-reuse`, null, {
      context: new HttpContext().set(SKIP_REFRESH_ON_401, true),
    });
  }
}
